module.exports = __webpack_public_path__ + "static/media/bank.7212d1c6.svg";